import { toast } from 'sonner';
import { BANNER_MS } from './curacionCopys';

/* PIPE-INST T5 (firma #122) — SACAR UN AVISO MOMENTÁNEO, CON EL BANNER DE LA CASA.
 *
 * ── POR QUÉ ESTO EXISTE Y NO ES `toast(...)` A PELO ─────────────────────────
 *
 * Por una sola razón: LA CLAVE. Los avisos de esta tanda los produce un diff que
 * corre cada cuatro segundos, y el mismo final puede volver a aparecer en el
 * siguiente tic si algo va lento o si el profesor abre dos pestañas. `toast()` a
 * secas sacaría el mismo renglón dos veces; con `id` —que en sonner es la
 * identidad de un toast— el segundo REEMPLAZA al primero en vez de apilarse.
 *
 * ── NO SE INVENTA UN COMPONENTE VISUAL NUEVO, Y ES LA FIRMA ─────────────────
 *
 * Se usa el MISMO `toast` de `sonner` que ya saca el copy 10 («Empezamos a
 * generar. Puedes salir; aquí mismo verás el avance.»), con el mismo `<Toaster>`
 * del chasis (App.js). Eso da gratis las tres
 * cosas que la firma pide y que un componente propio habría tenido que
 * reimplementar y volver a probar:
 *
 *   · **Arriba**, donde el profesor mira cuando algo acaba de pasar.
 *   · **EN FILA.** Si tres temas terminan casi a la vez, salen uno debajo de
 *     otro y nunca encimados. CADUCA (smoke-alumno, S5) lo de que "el resto
 *     espera turno": como mucho van tres a la vez y el cuarto SACA al más viejo
 *     (nada queda escondido detrás), y cada aviso se va solo con su duración
 *     aunque el dedo deje la lista "expandida" (`components/ui/sonner.jsx`).
 *   · **`aria-live="polite"`.** Lo lleva el `<section>` del propio `<Toaster>`
 *     (sonner 2.0.7, dist/index.mjs:1084), así que el lector de pantalla canta
 *     cada aviso cuando llega, sin que la pantalla recargue.
 *
 * Y da también el `safe-area-inset-top` que el envoltorio de la casa
 * (`components/ui/sonner.jsx`) le añadió para que en el WebView de iOS los avisos
 * no salgan debajo del notch. Un componente nuevo habría vuelto a pisar ese bug.
 */

/** Los tres tonos, mapeados a las variantes de sonner que el producto ya usa.
 *  `aviso` es el de "esto salió a medias": ni verde (no terminó entero) ni rojo
 *  (sí produjo material).
 *
 *  dashboard-rediseno (firma 4): desde esta tanda los avisos ya no llevan fondo
 *  de color; el tono se ve SOLO en el icono, con estos colores (los lee el
 *  `Toaster` de la casa, `components/ui/sonner.jsx`). `neutro` es el de un aviso
 *  sin tono. */
export const COLOR_DEL_ICONO = Object.freeze({
  exito: '#4ADE80',
  error: '#F87171',
  aviso: '#F7A06A',
  neutro: '#D4D4D4',
});

const POR_TONO = {
  exito: toast.success,
  error: toast.error,
  aviso: toast.warning,
};

/**
 * Saca en fila los avisos que le pasen. Idempotente por `clave`.
 *
 * @param {Array<{clave: string, texto: string, tono: string}>} avisos
 */
export function sacarBanners(avisos) {
  for (const aviso of avisos || []) {
    if (!aviso?.texto) continue;
    const sacar = POR_TONO[aviso.tono] || toast;
    sacar(aviso.texto, { id: aviso.clave, duration: BANNER_MS });
  }
}
